import React, { FunctionComponent } from 'react';
import { useTheme } from '@mui/material';
import InviteUserForm from './InviteUserForm';
import ModalDialog from '../../common/components/ModalDialog';
import { InvitationInput, Role } from '../types/members-types';

interface IInviteUserModalProps {
  open: boolean;
  onClose: () => void;
  onInvite: (invitationInput: InvitationInput) => void;
  availableRoles: Role[];
  isInviteEnabled: boolean;
  isInviteButtonLoading: boolean;
  hasErrorMessage: boolean;
  errorMessage: string;
}

const InviteUserModal: FunctionComponent<
  React.PropsWithChildren<IInviteUserModalProps>
> = props => {
  const theme = useTheme();

  const {
    open,
    onClose,
    onInvite,
    isInviteEnabled,
    availableRoles,
    isInviteButtonLoading,
    hasErrorMessage,
    errorMessage,
  } = props;

  return (
    <ModalDialog
      modalColor={theme.palette.info.main}
      aria-label='Invite a teammate'
      open={open}
      onClose={onClose}
      modalHeader='Invite a teammate'>
      <InviteUserForm
        onInvite={onInvite}
        onClose={onClose}
        isInviteEnabled={isInviteEnabled}
        availableRoles={availableRoles}
        isInviteButtonLoading={isInviteButtonLoading}
        hasErrorMessage={hasErrorMessage}
        errorMessage={errorMessage}
      />
    </ModalDialog>
  );
};

export default InviteUserModal;
